<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item label="开始时间">
					<el-date-picker
						v-model="filters.entimes"
						value-format="yyyy-MM-dd"
						style="width:100%"
						 type="date"
						 placeholder="选择日期"
					   />
				</el-form-item>
				<el-form-item label="结束时间">
					<el-date-picker
						v-model="filters.entimee"
						value-format="yyyy-MM-dd"
						style="width:100%"
						 type="date"
						 placeholder="选择日期"
					   />
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.mobile" placeholder="手机号码"></el-input>
				</el-form-item>
				<el-form-item>
					<el-select 
						v-model="filters.spcode" filterable placeholder="选择上游" class="h-m-select">
					  <el-option v-for="item in splist"
						:key="item.spcode" :label="item.name" v-model="item.spcode">
					  </el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select 
						v-model="filters.cpcode" filterable placeholder="选择渠道" class="h-m-select">
					  <el-option v-for="item in cplist"
						:key="item.cpcode" :label="item.cpname" v-model="item.cpcode">
					  </el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.service_code" placeholder="业务代码" @keyup.enter.native="getLists"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="getLists">搜索</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<!--列表-->
		<el-table :data="datalist" border stripe highlight-current-row v-loading="listLoading" style="width:90%;" height="600">
			<el-table-column prop="entime" label="时间" min-width="100">
				<template slot-scope="scope">
					{{scope.row.entime}}: <font color="green">{{scope.row.mobile}}</font>: 
					<font color="blue" v-if="scope.row.type=='sendCode'">申请</font>
					<font color="green" v-else-if="scope.row.type=='doSubmit'">提交</font>
					<font color="#FF8877" v-else>{{scope.row.type}}</font>
					{{scope.row.cporder}}
					<br/>
					{{scope.row.spcode}}:{{scope.row.spname}},<font color="blue">{{scope.row.service_code}}:{{scope.row.service_name}}</font>
					,{{scope.row.cpcode}}:{{scope.row.cpname}}<br/>
					platform:<font v-if="scope.row.platform!=''" color="blue">{{scope.row.platform}}</font> 
					<font v-else color="red">无平台</font> 
					<font color="green">{{scope.row.pack}}:{{scope.row.app_name}}</font>
					<br/>
					<font v-if="scope.row.ua!=''">ua:{{scope.row.ua}}<br/></font>
					<font >ip:{{scope.row.ip}}<br/></font>
					{{scope.row.reqsend}}<br/>
					参数:{{scope.row.req_params}}<br/>
					返回:{{scope.row.req_back}}
				</template>
			</el-table-column>
		</el-table>
		<!--工具条翻页-->
		<el-col :span="24" class="toolbar">
		<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="pagesize" :total="total" style="float:right;"></el-pagination>
		</el-col>

		<!--编辑界面-->
		<el-dialog :title="editformtitle" :visible.sync="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="100px" :rules="formRules" ref="editForm">
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>
<script>
	import util from '../../common/js/util'
	import { getListPage, delData, saveData } from '../../api/api';
	export default {
		data() {
			return {
				filters:{
					service_code:'',cpcode:'',spcode:'',mobile:'',entimes:'',entimee:''
				},
				datalist: [],
				total: 0,
				pagesize:20,
				page: 1,
				listLoading: false,
				splist:[],
				cplist:[],
				/////////////Form 表单
				editformtitle:'',//form编辑名称
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				formRules: {
				},
				//编辑界面数据
				editForm: {
					actionurl:'',sqlid:'',entime:'',service_code:'',cpcode:'',spcode:'',service_name:'',mobile:''
				}
			}
		},
		methods: {
			getLists:function(){
				//选择月份
				let tblTime = this.filters.entimes;
				if(tblTime.length>7) {
					tblTime = tblTime.substring(0,7);
				}
				if(util.formatDate.getdatestr(0, 'yyyy-MM')==tblTime){
					tblTime = '';
				}else{
					tblTime = '_'+tblTime.substring(0,4)+tblTime.substring(5,7);
				}
				let para = {
					page: this.page,
					pagesize:this.pagesize,
					actionurl:'default/getList',
					service_code:this.filters.service_code,
					cpcode:this.filters.cpcode,
					spcode:this.filters.spcode,
					mobile:this.filters.mobile,
					entimes:this.filters.entimes,
					entimee:this.filters.entimee,
					queryTbl:tblTime,
					sqlid:'sp_reqData.query'
				};
				this.listLoading = true;
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.total = res.data.total;
						this.datalist = res.data.datas;
						if(this.total<=0&&tblTime.length>0&&this.filters.mobile.length>0){
							this.getListByMobile();
						}
					}
					this.listLoading = false;
				});
			},
			getListByMobile:function(){
				let para = {
					page: this.page,
					pagesize:this.pagesize,
					actionurl:'default/getList',
					service_code:this.filters.service_code,
					cpcode:this.filters.cpcode,
					spcode:this.filters.spcode,
					mobile:this.filters.mobile,
					entimes:this.filters.entimes,
					entimee:this.filters.entimee,
					sqlid:'sp_reqData.query'
				};
				this.listLoading = true;
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.total = res.data.total;
						this.datalist = res.data.datas;
					}
					this.listLoading = false;
				});
			},
			handleCurrentChange(val) {
				this.page = val;
				this.getLists();
			},
			getSpList(){
				let para = {
					actionurl:'default/getListAll',
					sqlid:'sp_spinfo.query'
				};
				getListPage(para).then((res) => {
					if(res.data.status==-200){
						this.$message({
							message: res.data.message,
							type: res.data.type
						});
					}else{
						this.splist = res.data.datas;
					}
				});
				
			},
			getCpList(){
				let para = {
					actionurl:'default/getListAll',
					sqlid:'sp_cpinfo.query'
				};
				getListPage(para).then((res) => {
					if(res.data.status==-200){
						this.$message({
							message: res.data.message,
							type: res.data.type
						});
					}else{
						this.cplist = res.data.datas;
					}
				});
				
			},
			handleAdd:function(){
				this.editFormVisible = true;
				this.editformtitle = '新增';
				this.editForm = {
					actionurl:'default/save',sqlid:'sp_reqData.add',entime:'',service_code:'',cpcode:'',spcode:'',service_name:'',mobile:''
				};
			},
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editformtitle = '编辑';
				this.editForm = Object.assign({}, row);
				this.editForm.actionurl = 'default/save';//设置Sqlid
				this.editForm.sqlid = 'sp_reqData.upt';
			},
			editSubmit:function(){
				let para = Object.assign({}, this.editForm);
				util.saveFunction(this,para);
			},
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {type: 'warning'}).then(() => {
					this.listLoading = true;
					let para = {
						actionurl:'default/del',
						sqlid:'sp_reqData.del',
						id:row.id
					};
					delData(para).then((res) => {
						this.listLoading = false;
						this.$message({message: res.data.message,type: res.data.type});
						this.getLists();
					});
				}).catch(() => {});
			}
		},
		mounted() {
			this.filters.entimes = util.formatDate.getdatestr(0, 'yyyy-MM-dd');
			this.filters.entimee = util.formatDate.getdatestr(0, 'yyyy-MM-dd');
			this.getSpList();
			this.getCpList();
			this.getLists();
		}
	}	
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// reqData.vue?17d7df2d